
import { React, useEffect, useState, useRef } from "react";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import CompanyLogo from "../../images/Ellipse.svg"
import "./SalesOrder.scss";
import Autocomplete from "@mui/material/Autocomplete";
import { sidebarReducer } from "../../Redux/store";
import TextField from "@mui/material/TextField";
import Dropdown from "../../images/dropdown-icon.svg";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useDispatch } from "react-redux";
import { ToastContainer, toast } from 'react-toastify';
import { isValidPhoneNumber, isPossiblePhoneNumber } from 'libphonenumber-js';
import {
    SuccessAlert,
    FailureAlert,
} from "../../components/Alert_msg/alert_msg";
import { Tooltip } from 'react-tooltip';
import { useNavigate, useParams, useLocation } from "react-router-dom";


function CreateOrder() {
    const navigate = useNavigate();
    const location = useLocation();
    const [isEditingOrder, setIsEditingOrder] = useState(false);
    const fileInputRef = useRef(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [versions, setVersions] = useState([]);
    const [selectedVersion, setSelectedVersion] = useState("");
    const [selectedUploadId, setSelectedUploadId] = useState("")
    const [companyDetailsList, setCompanyDetailsList] = useState(null);
    const [phone, setPhone] = useState();
    const [selectedCountryCode, setSelectedCountryCode] = useState('');
    const [isLicenseGenerated, setIsLicenseGenerated] = useState(false);
    const [license_key, setlicense_key] = useState(null)
    const [selectedSize, setSelectedSize] = useState('');
    const [selectedImageFile, setSelectedImageFile] = useState(null);
    const [showCompanyDetails, setShowCompanyDetails] = useState(false);
    const [companies, setCompanies] = useState([[]]);
    const [software, setSoftware] = useState([[]]);
    const [softwareChecked, setSoftwareChecked] = useState([{ te_prepid: "" }]);
    const dispatch = useDispatch();
    const [missingFields, setMissingFields] = useState([]);
    const [companySoftwareDetailsList, setCompanySoftwareDetailsList] = useState(null);
    const [isCompanySelected, setIsCompanySelected] = useState(true);
    const [quotationRefNo, setQuotationRefNo] = useState("");
    const [isQuotationRefNoEmpty, setIsQuotationRefNoEmpty] = useState(true);
    const [selectedSoftware, setSelectedSoftware] = useState("");
    const [softwareTouched, setSoftwareTouched] = useState(false);
    const [versionTouched, setVersionTouched] = useState(false);
    const [issueDateTouched, setIssueDateTouched] = useState(false);
    const [expiryDateTouched, setExpiryDateTouched] = useState(false);
    const [issueDate, setIssueDate] = useState('');
    const [expiryDate, setExpiryDate] = useState('');
    const [spoc_details, setSpoc_details] = useState({
        contact: "",
        email: "",
        role: "Admin",
    });
    const [disableSpoc, setDisableSpoc] = useState(true);
    const [selectedCompanyForm, SetSelectedCompanyForm] = useState({
        te_customername: "",
        te_companyemail: "",
        te_companyphonenumber: "",
        te_companycountrycodes: "",
        te_companyid: "",
        te_prepid: "",
        te_ordernumber: "",
        te_companyname: "",
    });
    const [selectedCompanySoftwareForm, SetSelectedCompanSoftwareForm] = useState({
        te_software: "",
    });
    const [orderDetails, setOrderDetails] = useState({
        te_ordernumber: '',
        te_invoicerefno: '',
        createdat: '',
        customer_name: '',
        te_companyid: '',
        phone: '',
        email: '',
        roleid: '',
        te_prepid: '',
        te_version: '',
        te_size: '',
        te_issueedate: '',
        te_releasedate: '',
        license_key: '',
        technisian_name: '',
        order_discription: '',
        te_uploadid: "",
        te_software: "",
        te_bundlename: ""
    });

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const userParam = params.get("orderid");

        if (userParam) {
            setIsEditingOrder(true)
            fetchOrderDetails();
            setIsLicenseGenerated(true)
        }
    }, [location.search]);

    const heading =
        window.location.pathname === "/CreateOrder/" ? "Edit New Sales order" : "Create New Sales order";

    useEffect(() => {

        if (isEditingOrder == true) {

            const fetchCompanyAdminDetails = async (companyId) => {
                try {
                    const response = await axios.get(
                        `/v1/companyprofile/getCompanyAdmin/${companyId}`,
                        {
                            headers: {
                                'Authorization': 'Bearer ' + sessionStorage.getItem("access_token"),
                            }
                        }
                    );
                    setSpoc_details({
                        contact: response.data.data.te_phone ? response.data.data.te_phone : "",
                        email: response.data.data.te_useremail ? response.data.data.te_useremail : "",
                        role: "Admin"
                    });
                    setDisableSpoc(true);
                } catch (error) {
                    console.error("Error fetching company admin details:", error);
                    setSpoc_details({
                        contact: "",
                        email: "",
                        role: "Admin"
                    });
                    setDisableSpoc(false);
                }
            };

            if (orderDetails.te_invoicerefno) {
                setQuotationRefNo(orderDetails.te_invoicerefno);
            }

            if (orderDetails) {
                setSelectedSoftware(orderDetails.te_prepid);
                setSoftwareTouched(true);
                setSelectedUploadId(orderDetails.te_uploadid);
                setSelectedVersion(orderDetails.te_version);
                setSelectedSize(orderDetails.te_size);

            }

            if (orderDetails.te_companyid) {
                fetchCompanyAdminDetails(orderDetails.te_companyid);
            }
        }
    }, [orderDetails]);

    const fetchOrderDetails = async () => {
        try {
            const orderId = new URLSearchParams(location.search).get('orderid');
            setIsEditingOrder(!!orderId);
            const response = await axios.get(`/v1/orderdetails/list/${orderId}`,
                {
                    headers: {
                        'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token"),
                    }
                }
            );
            const orderData = response.data.data.data;

            // console.log("orderData", response.data.data.data)

            setOrderDetails({
                te_ordernumber: orderData.te_ordernumber,
                te_invoicerefno: orderData.te_invoicerefno,
                createdat: new Date(orderData.te_orderdate).toLocaleDateString(),
                customer_name: orderData.master_company.te_customername,
                te_companyid: orderData.master_company.te_companyid,
                te_prepid: orderData.license_detail.te_prepid,
                te_version: orderData.te_version,
                te_size: orderData.te_size,
                te_issueedate: orderData.license_detail.te_licenseactivationdate,
                te_releasedate: orderData.license_detail.te_licenseexpirationdate,
                license_key: orderData.te_lmsid,
                technisian_name: '',
                te_orderdescription: orderData.license_detail.te_orderdescription,
                te_uploadid: orderData.license_detail.te_uploadid,
                te_software: orderData.te_software,
                te_bundlename: orderData.te_bundlename
            });

            const formatDate = (dateString) => {
                const dateObj = new Date(dateString);
                const year = dateObj.getFullYear();
                const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Ensure two digits for month
                const day = String(dateObj.getDate()).padStart(2, '0'); // Ensure two digits for day
                return `${year}-${month}-${day}`;

            };

            const formattedIssueDate = formatDate(orderData.license_detail.te_licenseactivationdate);
            const formattedExpiryDate = formatDate(orderData.license_detail.te_licenseexpirationdate);
            setIssueDate(formattedIssueDate);
            setExpiryDate(formattedExpiryDate);
            setSoftwareChecked({ te_prepid: orderData.license_detail.te_prepid });
            setSelectedSoftware(orderData.license_detail.te_prepid);


        } catch (error) {
            console.error('Error fetching order details:', error);
        }
    };


    useEffect(() => {
        clearData();
        getCompaniesList();
        getSoftwareList();



    }, []);
    const [isCreatingOrder, setIsCreatingOrder] = useState(false);


    const getSoftwareList = async () => {
        try {
            const response = await axios.get(
                '/v1/masterpack/listAllPacks', {
                headers: {
                    'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token"),
                }
            }
            );

            const data = response.data.data;

            setCompanySoftwareDetailsList(data)


            if (data.length > 0) {
                setSoftware(data.map(company => ({
                    value: company.te_companyid,
                    label: company.te_companyname
                })));
            } else {
                console.error("Invalid server response format:", data);
            }
        } catch (error) {
            console.error("Error fetching company details:", error);
        }
    }


    const getCompaniesList = async () => {
        setCompanyDetailsList([]);
        setCompanies([]);

        try {
            const response = await axios.get(
                '/v1/companyprofile/list', {
                headers: {
                    'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token"),
                }
            }
            );

            const data = response.data.data.rows;

            setCompanyDetailsList(data)
            if (data.length > 0) {
                setCompanies(data.map(company => ({
                    value: company.te_companyid,
                    label: company.te_companyname
                })));
            } else {
                console.error("Invalid server response format:", data);
            }
        } catch (error) {
            console.error("Error fetching company details:", error);
        }
    }

    const handleSubmitCompany = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const formValues = Object.fromEntries(formData.entries());
        formValues.companynumber = phone;
        if (selectedImageFile) {
            formValues.te_companylogosmall = selectedImageFile
        }
        validatecompanyForm(formValues);
    }

    const handleLogoClick = (event) => {
        event.preventDefault();
        fileInputRef.current.click();
    };


    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedImageFile(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setSelectedImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSelectComapany = async (value) => {

        let selectedCompanyItem = companyDetailsList.find(company => company.te_companyid === value);

        SetSelectedCompanyForm((prevData) => ({
            ...prevData,
            te_companyphonenumber: selectedCompanyItem.te_companyphonenumber
        }));
        SetSelectedCompanyForm((prevData) => ({
            ...prevData,
            te_companyemail: selectedCompanyItem.te_companyemail
        }));
        SetSelectedCompanyForm((prevData) => ({
            ...prevData,
            te_companycountrycodes: selectedCompanyItem.te_companycountrycodes
        }));
        SetSelectedCompanyForm((prevData) => ({
            ...prevData,
            te_customername: selectedCompanyItem.te_customername
        }));
        SetSelectedCompanyForm((prevData) => ({
            ...prevData,
            te_companyid: selectedCompanyItem.te_companyid
        }));

        try {
            const response = await axios.get(
                `/v1/companyprofile/getCompanyAdmin/${value}`,
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem("access_token"),
                    }
                }
            );
            setSpoc_details({
                contact: response.data.data.te_phone ? response.data.data.te_phone : "",
                email: response.data.data.te_useremail ? response.data.data.te_useremail : "",
                role: "MASTER_ADMIN"
            }
            )
            setDisableSpoc(true)
        } catch (error) {
            console.error("Error fetching company admin details:", error);
            setSpoc_details({
                contact: "",
                email: "",
                role: "MASTER_ADMIN"
            }
            )
            setDisableSpoc(true)
        }
    }

    const handleSelectComapanySoftware = (value) => {
        setSoftwareChecked(companySoftwareDetailsList.find(company => company.te_prepid === value));

        SetSelectedCompanSoftwareForm((prevData) => ({
            ...prevData,
            te_prepid: softwareChecked.te_prepid
        }));

    }
    const handleSelectComapanyChange = (event) => {
        handleSelectComapany(event.target.value);
        setIsCompanySelected(true);
        setDisableSpoc(true)

    };

    const handleSelectComapanySoftwareChange = (event) => {
        setSelectedSoftware(event.target.value);
        console.log("selectedSoftware", selectedSoftware)
        setSoftwareTouched(true);
        handleSelectComapanySoftware(event.target.value);

        const selectedSoftwareId = event.target.value;
        setSoftwareChecked({ ...softwareChecked, te_prepid: selectedSoftwareId });

        console.log("te_bundlename", softwareChecked)

        axios.get(`/v1/masterpack/list/${selectedSoftwareId}`,
            {
                headers: {
                    'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token"),
                }
            }
        )
            .then(response => {
                const fetchedVersions = response.data.data[0].masterpack_bundles;
                setVersions(fetchedVersions);
                if (fetchedVersions.length > 0) {
                    setSelectedVersion(fetchedVersions[0].te_version);
                    setSelectedSize(fetchedVersions[0].te_bundlesizeingb);
                    setSelectedUploadId(fetchedVersions[0].te_uploadid);
                }
            })
            .catch(error => {
                console.error('Error fetching versions:', error);
            });

    };

    const handleSubmitOrder = (event) => {
        event.preventDefault();

        if (isCreatingOrder) {
            return;
        }
        setIsCreatingOrder(true);

        const formData = new FormData(event.target);
        const orderFormValues = Object.fromEntries(formData.entries());


        orderFormValues.te_companyid = selectedCompanyForm.te_companyid;
        let selectedSoftware = companySoftwareDetailsList.find(
            (company) => company.te_prepid === orderFormValues.te_prepid
        );

        let orderData = {
            "te_ordernumber": selectedCompanyForm.te_ordernumber,
            "te_invoicerefno": orderFormValues.te_invoicerefno,
            "te_companyid": orderFormValues.te_companyid,
            "createdat": new Date().toLocaleDateString(),
            "te_software": selectedSoftware ? selectedSoftware.te_bundlename : "",
            "te_version": selectedVersion,
            "te_size": orderFormValues.te_size,
            "te_lmsid": document.getElementById("license_key").value,
            "te_orderdescription": orderFormValues.te_orderdescription,
            "te_prepid": orderFormValues.te_prepid, 
            "te_isdeactivatedat": orderFormValues.te_releasedate,
            "te_ordercreatedby":JSON.parse(sessionStorage.getItem("userdata")).te_username,
        }

        event.target.reset();

        if (isEditingOrder == true) {

            updateOrder(orderData);

        } else {
            setNewOrder(orderData);
        }

    }
    const setNewOrder = async (orderFormValues) => {

        try {
            const response = await axios.post(
                '/v1/orderdetails/add', orderFormValues, {
                headers: {
                    'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token"),
                }
            }
            );


            dispatch(sidebarReducer.apiLoad(false));
            if (
                response.data.message ===
                `Oder already exists`
            ) {
                toast.warn('Order Already Exists', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });

            }

            else {
                toast.success('Order creation successfull', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    onClose: () => {
                        window.location.reload();
                    }
                });
                clearData();
                setIsCreatingOrder(true);
                // window.location.reload();
            }

        } catch (error) {
            console.error("Error fetching company details:", error);
            toast.error(error.response.data.message, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            setIsCreatingOrder(false);

        }
    }

    const updateOrder = async (orderFormValues) => {

        orderFormValues.te_ordernumber = orderDetails.te_ordernumber;
        const orderId = new URLSearchParams(location.search).get('orderid');
        try {
            const response = await axios.put(`/v1/orderdetails/updateOrder/${orderId}`, orderFormValues, {
                headers: {
                    'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token"),
                }
            });

            setIsCreatingOrder(false);

            dispatch(sidebarReducer.apiLoad(false));
            if (
                response.data.message ===
                `Oder already exists`
            ) {
                toast.warn('Order Already Exists', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });

            }
            else if (response.data.message == 'ORDER DETAILS UPDATED SUCCESSFULLY') {
                toast.success(response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    onClose: () => {
                        navigate("/SalesOrder");
                    }
                });
            }
            else {
                toast.warn(response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                clearData();
                // window.location.reload();
            }

        } catch (error) {
            console.error('Error updating order:', error);

        }
    }
    const clearData = () => {
        SetSelectedCompanyForm({
            te_customername: "",
            te_companyemail: "",
            te_companyphonenumber: "",
            te_companycountrycodes: "",
            te_companyid: "",
            te_ordernumber: "",
            te_companyname: "",
        });
        SetSelectedCompanSoftwareForm({
            te_software: "",
        });
        setSpoc_details({
            contact: "",
            email: "",
            role: "Admin",
        });
        setSoftwareChecked({});
        setSelectedVersion("");
        setIssueDate("");
        setExpiryDate("");
        setIssueDateTouched(false);
        setExpiryDateTouched(false);
        setVersionTouched(false);
        setQuotationRefNo("");
        setlicense_key("")
        setSelectedSize("")
        setOrderDetails({
            te_ordernumber: "",
            te_invoicerefno: "",
            createdat: "",
            customer_name: "",
            te_companyid: "",
            phone: '',
            email: '',
            roleid: '',
            te_prepid: '',
            te_version: '',
            te_size: '',
            te_issueedate: '',
            te_releasedate: '',
            license_key: '',
        })

    }
    const validatecompanyForm = (formValues) => {

        let missingFields = [];
        if (!formValues.companyname.trim()) {
            missingFields.push('companyname');
        }
        if (!formValues.customername.trim()) {
            missingFields.push('customername');
        }
        if (!formValues.companyurl.trim()) {
            missingFields.push('companyurl');
        }
        if (!formValues.companynumber) {
            missingFields.push('companynumber');
        }

        if (!formValues.companyemail.trim()) {
            missingFields.push('companyemail');
        }

        if (!formValues.companyaddress.trim()) {
            missingFields.push('companyaddress');
        }

        setMissingFields(missingFields);


        formValues.companycountrycode = selectedCountryCode;
        formValues.companydisplayName = formValues.companyname

        if (missingFields.length === 0) {
            const formData = new FormData();
            formData.append('companyname', formValues.companyname);
            formData.append('companydisplayName', formValues.companyname);
            formData.append('companyaddress', formValues.companyaddress);
            formData.append('companyurl', formValues.companyurl);
            formData.append('companyemail', formValues.companyemail);
            formData.append('companynumber', formValues.companynumber);
            formData.append('companycountrycode', formValues.companycountrycode);
            formData.append('customername', formValues.customername);
            // formData.append('technisian_name', formValues.technisian_name);
            if (formValues.te_companylogosmall) {
                formData.append('te_companylogosmall', formValues.te_companylogosmall);
            }
            createAddCompany(formData);

            console.log("missingFields.length", missingFields.length);
        } else {
            console.log("Form has missing fields");
        }

    };

    async function createAddCompany(formData) {
        console.log(formData)
        dispatch(sidebarReducer.apiLoad(true));
        await axios
            .post("v1/companyprofile/add",
                formData, {
                headers: {
                    'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token"),
                }
            })
            .then((response) => {
                getCompaniesList();
                if (response.status == 200) {
                    dispatch(sidebarReducer.apiLoad(false));

                    if (
                        response.data.message ===
                        `Company name comapnyDetails.companyname already exists`

                    ) {
                        toast.warn('Company Already Exists', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });


                    } else {
                        toast.success('Company creation successfull', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });
                        setSelectedImage('')

                    }


                } else if (response.status !== 201) {
                    dispatch(sidebarReducer.apiLoad(false));
                    toast.error('Company creation unsuccessfull', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });

                }
                setShowCompanyDetails(false);
            })
            .catch((err) => {
                dispatch(sidebarReducer.apiLoad(false));
                toast.error(err.response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setShowCompanyDetails(false);
            });

    };
    useEffect(() => {

    }, [companies]);

    const SPOCDataSubmit = async () => {
        let selectedCompanyItem = companyDetailsList.find(company => company.te_companyid === selectedCompanyForm.te_companyid);

        let spocData = {
            "username": selectedCompanyForm.te_customername,
            "firstname": selectedCompanyForm.te_customername,
            "lastname":  selectedCompanyForm.te_customername,
            "email": document.getElementById('order_email').value,
            "phone": document.getElementById('phone').value,
            "usertype": "platform",
            "divisionid": "1",
            "roleid": "87",
            "companyid": selectedCompanyForm.te_companyid,
            "te_useractivatedat": document.getElementById('te_issueedate').value,
            "te_userdeactivatedat": document.getElementById('te_releasedate').value,
        }
        try {

            const response = await axios.post(
                '/v1/cmsuser/add', spocData, {
                headers: {
                    'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token"),
                }
            }
            );
            if (response.data.status === 200) {
            
        if (response.data.message === "CMS USER ADDED SUCCESSFULLY") {
         
            toast.success("SPOC details added successfully", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            setDisableSpoc(true)
        }
        else {
            console.log("elseresponse", response);
            toast.warn(response.data.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
            
        }
        else {
           
            toast.warn(response.data.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        } catch (error) {
        
            setDisableSpoc(false)
            // console.log(error.response)
            if(error.response && error.response.data && Array.isArray(error.response.data.data)){
                console.log("abcdddd")
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
            else{
            toast.error(error.response.data.data, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            setDisableSpoc(false)
        }
        }
    }


    const [isLicenseKeyAdded, setIsLicenseKeyAdded] = useState(false);
    
    const generateLicense = async () => {
        if (!selectedCompanyForm.te_companyid && !quotationRefNo.trim() && !selectedSoftware && !selectedVersion && !issueDate && !expiryDate) {
            setIsCompanySelected(false);
            setIsQuotationRefNoEmpty(false);
            setSoftwareTouched(true);
            setVersionTouched(true);
            setIssueDateTouched(true);
            setExpiryDateTouched(true);
            return;
        }
        // setSpoc_details(prevDetails => ({
        //     contact: prevDetails.contact.trim(),
        //     email: prevDetails.email.trim(),
        //     role: prevDetails.role.trim(),
        // }));
        if (!selectedCompanyForm.te_companyid) {
            setIsCompanySelected(false);
            return;
        }

        if (!quotationRefNo.trim()) {
            setIsQuotationRefNoEmpty(false);
            return;
        }
        if (!selectedSoftware) {
            setSoftwareTouched(true);
            return;
        }
        if (!selectedVersion) {
            setVersionTouched(true);
            return;
        }
        if (!issueDate) {
            setIssueDateTouched(true);
            return;
        }
        if (!expiryDate) {
            setExpiryDateTouched(true);
            return;
        }
     

        let generateLicenseData = {
            "te_companyid": selectedCompanyForm.te_companyid,
            // "te_islicenseactivated": true,
            "te_licenseactivationdate": document.getElementById('te_issueedate').value,
            "te_licenseexpirationdate": document.getElementById('te_releasedate').value,
            "te_orderid": selectedCompanyForm.te_ordernumber,
            // "te_licenseperiod": 6,
            "te_licenseusedbyusers": 15,
            "te_extendlicencedescription": "new license",
            "te_iscreatedby": JSON.parse(sessionStorage.getItem("userdata")).te_username,
            "te_prepid": softwareChecked.te_prepid,
            "te_uploadid": selectedUploadId,
        }

        try {
            const response = await axios.post(
                '/v1/licensedetails/add', generateLicenseData, {
                headers: {
                    'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token"),
                }
            }
            );
            console.log(response.data.message)
            let data = response.data.data;

            if (data) {
                let licenseField = document.getElementById("license_key");

                licenseField.value = data.te_lmsid;

                setIsLicenseGenerated(true);
                setIsCreatingOrder(false);
                setlicense_key(licenseField.value)
               if(response.data.message==="LICENSE KEY ADDED SUCCESSFULLY"){
                toast.success(response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setIsLicenseKeyAdded(true);
                setDisableSpoc(false)

            }
            else{
                toast.warn(response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
            } else {
                console.error("Invalid server response format:", data);
                console.log(response)
            }
        } catch (error) {
            console.error("Error fetching company details:", error);
            console.log(error)
        }
    }

    const handleSpocChange = (e) => {
        setSpoc_details({ ...setSpoc_details, [e.target.name]: e.target.value });

    };
    const handlePhoneNumberInput = (e) => {
       
        const isDigitOrControlKey = /^[\d]$|^[\b\d,\+\-]$/.test(e.key);

        // If the input is not a digit or control key, prevent the input
        if (!isDigitOrControlKey) {
            e.preventDefault();
        }
    };

    const handleSpocEmailChange = (e) => {
        const { value } = e.target;
        const trimmedValue = value.trim();
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
        const isValidEmail = emailPattern.test(trimmedValue);
        const emailError = document.getElementById('emailError');

        if (trimmedValue) {
            if (!isValidEmail) {
                emailError.innerText = 'Email Id is not valid';
            } else {
                emailError.innerText = '';
            }
        } else {
            emailError.innerText = '';
        }

        setSpoc_details({ ...spoc_details, email: value });
    };






    const handleClearSelection = () => {
        setShowCompanyDetails(false);
    };

    const handleIssueDateChange = (e) => {
        setIssueDate(e.target.value);
        setIssueDateTouched(true);
    };


    const handleExpiryDateChange = (e) => {
        setExpiryDate(e.target.value);
        setExpiryDateTouched(true);
    };
    const formatDate = (date) => {
        return new Date(date).toISOString().split('T')[0];
    };
    const getNextDay = (date) => {
        let nextDay = new Date(date);
        nextDay.setDate(nextDay.getDate() + 1);
        return formatDate(nextDay);
    };

    const getPreviousDay = (date) => {
        let previousDay = new Date(date);
        previousDay.setDate(previousDay.getDate() - 1);
        return formatDate(previousDay);
    };

    const today = formatDate(new Date());
    const minExpiryDate = issueDate ? getNextDay(issueDate) : getNextDay(today);
    const maxIssueDate = expiryDate ? getPreviousDay(expiryDate) : "";
    // const minExpiryDate = issueDate || today;
    // const maxIssueDate = expiryDate ? expiryDate : "";


    const [dataFetched, setDataFetched] = useState(false);

    useEffect(() => {
        if (selectedCompanyForm && selectedCompanyForm.te_companyid && !dataFetched) {
            const companyId = selectedCompanyForm.te_companyid;
            axios.get(`/v1/orderdetails/getOrderNumberFromCompany/${companyId}`, {
                headers: {
                    'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token"),
                }
            })
                .then(response => {
                    const orderNumber = response.data.data.orderNumber;

                    SetSelectedCompanyForm(prevState => ({
                        ...prevState,
                        te_ordernumber: orderNumber
                    }));

                    setDataFetched(true);
                })
                .catch(error => {
                    console.error('Error fetching order number:', error);
                });
        }
    }, [selectedCompanyForm, dataFetched]);


    const handleEmailInputChange = (e) => {
        const { value } = e.target;
        const trimmedValue = value.trim();
        if (trimmedValue) {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
            const isValidEmail = emailPattern.test(trimmedValue);
            const emailError = document.getElementById('emailError');
            if (!isValidEmail) {
                document.getElementById('emailError').innerText = 'Email Id is not valid';
                emailError.style.color = 'red';
                emailError.style.fontSize = '10px';
            } else {
                document.getElementById('emailError').innerText = '';
            }
        } else {
            document.getElementById('emailError').innerText = '';
        }
    };




    const handlePhoneInputChange = (value, country, e, formattedValue) => {

        let phoneError = document.getElementById('phoneError');
        let trimmedValue = value.trim();


        if (trimmedValue) {


            if (isPossiblePhoneNumber(formattedValue, country.dialCode) === false) {
                document.getElementById('phoneError').innerText = 'Phone number is invalid';
                phoneError.style.color = 'red';
                phoneError.style.fontSize = '10px';
            }
            else if (country.dialCode === '91' && formattedValue.length !== 15) {
                phoneError.innerText = 'Phone number is not valid';
                phoneError.style.color = 'red';
                phoneError.style.fontSize = '10px';
            }
            else if (country.dialCode === '91') {
                const indianMobilePattern = /^\+91[6-9]\d{9}$/;
                const cleanedFormattedValue = formattedValue.replace(/[^+\d]/g, '');
                const isValidIndianNumber = indianMobilePattern.test(cleanedFormattedValue);
                if (!isValidIndianNumber) {
                    phoneError.innerText = 'Phone number is invalid';
                    phoneError.style.color = 'red';
                    phoneError.style.fontSize = '10px';
                    return;
                }
                phoneError.innerText = '';
                setPhone(value);
                setSelectedCountryCode(country.dialCode);
            }

            else {
                document.getElementById('phoneError').innerText = '';
                setPhone(value);
                setSelectedCountryCode(country.dialCode);
            }
        }
        else {
            document.getElementById('emailError').innerText = '';
        }

    };

    const handleUrlInputChange = (e) => {
        const { value } = e.target;
        const trimmedValue = value.trim();

        const urlError = document.getElementById('urlError');
        if (urlError) {
            const urlPattern = /^(ftp|http|https):\/\/([^\s$.?#].[^\s]*)$/i;
            if (trimmedValue) {
                const isValidUrl = urlPattern.test(trimmedValue);
                if (!isValidUrl) {
                    urlError.innerText = 'URL is not valid';
                    urlError.style.color = 'red';
                    urlError.style.fontSize = '10px';
                } else {
                    urlError.innerText = '';
                }
            } else {
                urlError.innerText = '';
            }
        }
    };

    const handleCreateNewOrderClick = () => {
        navigate("/CreateOrder");
        setIsEditingOrder(false);
        clearData();
        window.location.reload();

    };

    return (
        <div className="scrollalign sales-page">
            <div className="d-flex  mb-2">
                <h5 style={{ marginRight: "auto", fontSize: "35px" }}>{heading}</h5>
                {/* <h5 style={{ marginRight: "auto", fontSize: "35px" }}>Create New Sales order</h5> */}
                {isEditingOrder && (
                    <button
                        className="create-button"
                        style={{ marginRight: "10px" }}
                        onClick={handleCreateNewOrderClick}

                    >
                        Create New Order
                    </button>
                )}
            </div>
            <div className='grid-outside'>
                <div className="container-grid p-0 m-0">

                    {!showCompanyDetails ? (

                        <div className='first-grid'>
                            <div className='small-grid-1' onClick={() => setShowCompanyDetails(true)} >
                                <p>Create Company</p>
                            </div>
                            <div className='small-grid-2'>

                                <div className="existing-company text-center">
                                    <p>Existing Company</p>
                                    <div >


                                        <Autocomplete
                                            className="company-dropdown"
                                            options={companies}
                                            getOptionLabel={(option) => option.label}
                                            popupIcon={<KeyboardArrowDownIcon />}
                                            disabled={isEditingOrder}
                                            onChange={(event, value) => {
                                                if (value) {
                                                    handleSelectComapany(value.value);
                                                } else {

                                                    handleClearSelection();
                                                }
                                            }}
                                            ListboxProps={{
                                                style: { maxHeight: '200px', overflow: 'auto' }
                                            }}
                                            renderInput={(params) => (
                                                <div>
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                    />
                                                </div>
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                    ) : (
                        <div className="companygrid-1">

                            <p className="Company-heading">Company Details</p>
                            <div className="Company-details">

                                <form id="companyForm" onSubmit={handleSubmitCompany}>
                                    <div className="company-info">

                                        <div className="logo-container align">

                                            <label htmlFor="fileInput" className="logo-label" onClick={handleLogoClick}>
                                                {selectedImage ? (
                                                    <>
                                                        <img src={selectedImage} className="Company-Logo" alt="Selected Logo" />
                                                        <p className="logo-text">Logo</p>
                                                    </>
                                                ) : (
                                                    <>
                                                        <img src={CompanyLogo} className="Company-Logo" alt="Company Logo" />
                                                        <p className="logo-text">Logo</p>
                                                    </>
                                                )}
                                            </label>
                                            <input
                                                type="file"
                                                id="fileInput"
                                                ref={fileInputRef}
                                                style={{ display: 'none' }}
                                                onChange={handleFileChange}
                                                accept="image/*"
                                            />
                                        </div>

                                        <div className=" align w-100">

                                            <label htmlFor="companyName">
                                                <span style={{ color: "red" }}>*</span>
                                                Company
                                            </label>
                                            <input
                                                type="text"
                                                name='companyname'
                                                id="companyname"
                                                className={`${missingFields.includes('companyname') ? 'missing-field' : ''}`}

                                            />
                                        </div>

                                    </div>
                                    <div className="align">
                                        <label htmlFor="customerName">
                                            <span style={{ color: "red" }}>*</span>Customer Name</label>
                                        <input
                                            type="text"
                                            name="customername"
                                            id="customerName"
                                            className={`${missingFields.includes('customername') ? 'missing-field' : ''}`}

                                        />
                                    </div>
                                    <div className="align">
                                        <label htmlFor="companyurl">
                                            <span style={{ color: "red" }}>*</span>Company URL</label>
                                        <input
                                            type="url"
                                            name="companyurl"
                                            id="companyURL"
                                            className={`${missingFields.includes('companyurl') ? 'missing-field' : ''}`}
                                            onChange={handleUrlInputChange}

                                        />
                                        <p id="urlError" style={{ color: 'red', marginBottom: "0" }}></p>
                                    </div>
                                    <div className="align">
                                        <label htmlFor="companynumber">
                                            <span style={{ color: "red" }}>*</span>Phone Number</label>

                                        <PhoneInput
                                            country={'in'}
                                            enableSearch={true}
                                            value={phone}
                                            onChange={handlePhoneInputChange}
                                            inputProps={{
                                                name: 'companynumber',
                                                id: 'companynumber',
                                                className: `phone-number ${missingFields.includes('companynumber') ? 'missing-field' : ''}`
                                            }}


                                        />
                                        <p id="phoneError" style={{ color: 'red', marginBottom: "0" }}></p>


                                    </div>
                                    <div className="align">
                                        <label htmlFor="emailId" for="emailId">
                                            <span style={{ color: "red" }}>*</span>Email Id</label>
                                        {/* <input
                                            type="email"
                                            name="companyemail"
                                            id="emailId"
                                            className={`${missingFields.includes('companyemail') ? 'missing-field' : ''}`}

                                        /> */}
                                        <input
                                            type="email"
                                            name="companyemail"
                                            id="emailId"
                                            className={`${missingFields.includes('companyemail') ? 'missing-field' : ''}`}
                                            onChange={handleEmailInputChange}
                                        />
                                        <p id="emailError" style={{ color: 'red', marginBottom: "0" }}></p>
                                    </div>
                                    <div className="align">
                                        <label htmlFor="companyAddress">
                                            <span style={{ color: "red" }}>*</span>Company Address</label>
                                        <input type="text"
                                            name="companyaddress"
                                            id="companyAddress"
                                            className={`${missingFields.includes('companyaddress') ? 'missing-field' : ''}`}

                                        />
                                    </div>
                                    <div>
                                        <button type="submit" className="create-company-button">Create Company</button>
                                    </div>
                                </form>
                            </div>

                        </div>
                    )}

                    <div className="grid-2">
                        <p className="Company-heading ">Order Details</p>
                        <div className="Order-details">
                            <form id="orderForm" onSubmit={handleSubmitOrder}>
                                <div style={{ display: "flex", gap: "10px" }}>
                                    <div className="align" style={{ flex: 1 }}>
                                        <label> <span style={{ color: "red" }}>*</span>Order Number</label>
                                        <input name="te_ordernumber" id="te_ordernumber"
                                            disabled
                                            value={orderDetails.te_ordernumber || selectedCompanyForm.te_ordernumber}
                                            //  value={selectedCompanyForm.te_ordernumber} 
                                            type="text"></input>
                                    </div>

                                    <div className="align" style={{ flex: 1 }}>
                                        <label><span style={{ color: "red" }}>*</span>Quotation Ref No</label>
                                        <input name="te_invoicerefno" 
                                        type="text"
                                        placeholder="Enter Quotation Ref No"
                                            onChange={(e) => {
                                                setQuotationRefNo(e.target.value);
                                                setIsQuotationRefNoEmpty(true);
                                            }}
                                            value={quotationRefNo}
                                            className={`${!isQuotationRefNoEmpty ? 'missing-field' : ''}`} required></input>
                                    </div>

                                    <div className="align" style={{ flex: 1 }}>
                                        <label>Order Date</label>
                                        <input name="createdat" disabled type="text" value={new Date().toLocaleDateString()} ></input>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: "10px" }}>
                                    <div style={{ flex: '2' }}>
                                        <div className="align" >
                                            <label htmlFor="customerName"> <span style={{ color: "red" }}>*</span>Customer</label>
                                            <input disabled name="customer_name"
                                                value={isEditingOrder ? orderDetails.customer_name : (selectedCompanyForm.te_customername)}
                                                type="text" id="customerName"

                                            />
                                        </div>
                                    </div>

                                    <div style={{ flex: '1' }}>

                                        <div className="align">
                                            <label htmlFor="companyName">
                                                <span style={{ color: "red" }}>*</span>Company</label>
                                            <div className="align dropdown-image">
                                                <select
                                                    className={` ${!isCompanySelected ? 'missing-field' : ''}`}
                                                    id='dropdown'
                                                    value={isEditingOrder ? orderDetails.te_companyid : (selectedCompanyForm.te_companyid != "" ? selectedCompanyForm.te_companyid : "")}
                                                    name='te_companyid'
                                                    disabled={isEditingOrder}
                                                    onChange={handleSelectComapanyChange}
                                                    
                                                >
                                                    <option value="" disabled >Select a company</option>
                                                    {companyDetailsList &&
                                                        companyDetailsList.map((company) => (
                                                            <option key={company.te_companyname} value={company.te_companyid}>
                                                                {company.te_companyname}
                                                            </option>
                                                        ))}
                                                </select>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                                <div style={{ display: "flex", gap: "10px", padding: "10px 0px 0px 0px" }}>

                                    <div className={`input-container `}>
                                        <label htmlFor="input-field">SPOC Contact</label>
                                        <div className="input-wrapper">
                                            <input
                                                className="customer_phone"
                                                type="tel"
                                                id="phone"
                                                onChange={handleSpocChange}
                                                value={spoc_details.contact}
                                                disabled={disableSpoc}
                                                name="phone"
                                                required
                                                onKeyPress={handlePhoneNumberInput}
                                            />
                                        </div>
                                    </div>
                                     <div>
                                    <div className={`input-container `}>
                                        <label htmlFor="input-field">SPOC Email</label>
                                        <div className="input-wrapper">
                                            <input
                                                name="email"
                                                type="email"
                                                id="order_email"
                                                onChange={handleSpocEmailChange}
                                                value={spoc_details.email}
                                                disabled={disableSpoc}
                                                required
                                            />
                                           
                                        </div>
                                    </div>
                                    <p id="emailError" style={{ color: 'red', marginBottom: "0" ,fontSize:"0.7rem"}}  ></p></div>

                                    <div className={`input-container `}>
                                        <label htmlFor="input-field">SPOC Role </label>
                                        <div className="input-wrapper">
                                            <input
                                                className="customer_role"
                                                type="text"
                                                id="roleid"
                                                name="roleid"
                                                onChange={handleSpocChange}
                                                value={spoc_details.role}
                                                disabled
                                                required
                                            />
                                        </div>
                                    </div>
                                    
                                    <button
                                        type="button"
                                        // className={`create-spoc-button ${disableSpoc ? 'disabled' : ''}`}
                                        className={`create-spoc-button ${disableSpoc || isEditingOrder ? 'disabled' : ''}`}
                                        onClick={SPOCDataSubmit}
                                        disabled={disableSpoc || isEditingOrder}
                                    >
                                        Create
                                    </button>
                                </div>
                                <div className="align">
                                    <label>Software Details</label>
                                    <div className="licence-details" style={{ display: 'flex', gap: "10px" }}>
                                        <div className="align">
                                            <label><span style={{ color: "red" }}>*</span>Software</label>
                                            <select
                                                id='dropdown'
                                                // value={softwareChecked.te_prepid != "" && softwareChecked.te_prepid ? softwareChecked.te_prepid : ""}

                                                // value={isEditingOrder ? orderDetails.te_prepid : (softwareChecked.te_prepid ? softwareChecked.te_prepid : "")}
                                                value={softwareChecked.te_prepid != "" && softwareChecked.te_prepid ? softwareChecked.te_prepid : ""}
                                                name='te_prepid'
                                                onChange={handleSelectComapanySoftwareChange}
                                                className={softwareTouched && !selectedSoftware ? 'missing-field' : ''}
                                            >
                                                <option value="" disabled >Select a software</option>
                                                {companySoftwareDetailsList &&
                                                    companySoftwareDetailsList.map((company) => (
                                                        <option key={company.te_bundlename} value={company.te_prepid}>
                                                            {company.te_bundlename}
                                                        </option>
                                                    ))}
                                            </select>

                                        </div>
                                        <div className="align">
                                            <label><span style={{ color: "red" }}>*</span>Version</label>

                                            <input
                                                type="text"
                                                //  value={isEditingOrder ? orderDetails.te_version : (versions.length > 0 ? versions[0].te_version : '')}
                                                value={selectedVersion}
                                                readOnly
                                            />
                                        </div>
                                        <div className="align" style={{ paddingBottom: "10px" }}>
                                            <label>Size</label>
                                            <input name="te_size"
                                                type="text"
                                                // value={isEditingOrder ? orderDetails.te_size : (versions.length > 0 ?versions[0].te_bundlesizeingb : '')}
                                                value={selectedSize}
                                                readOnly />
                                        </div>
                                        <div className="align-date">
                                            <label><span style={{ color: "red" }}>*</span>Issue Date</label>
                                            <input
                                                type="date"
                                                name="te_issueedate"
                                                required
                                                disabled={isEditingOrder}
                                                id="te_issueedate"
                                                onInvalid={(e) => e.target.setCustomValidity("Date is requied")}
                                                onInput={(e) => e.target.setCustomValidity("")}
                                                min={today}
                                                max={maxIssueDate}
                                                onChange={handleIssueDateChange}
                                                className={issueDateTouched && !issueDate ? 'missing-field' : ''}
                                                onKeyDown={(e) => e.preventDefault()}
                                                value={isEditingOrder ? issueDate : issueDate}
                                            />
                                        </div>
                                        <div className="align-date">
                                            <label><span style={{ color: "red" }}>*</span>Expiry Date</label>
                                            <input
                                                type="date"
                                                name="te_releasedate"
                                                required
                                                onChange={handleExpiryDateChange}
                                                min={minExpiryDate}
                                                id="te_releasedate"
                                                disabled={isEditingOrder}
                                                onInvalid={(e) => e.target.setCustomValidity("Date is requied")}
                                                onInput={(e) => e.target.setCustomValidity("")}
                                                className={expiryDateTouched && !expiryDate ? 'missing-field' : ''}
                                                onKeyDown={(e) => e.preventDefault()}
                                                value={isEditingOrder ? expiryDate : expiryDate}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: "10px" }}>
                                    <div style={{ flex: '2' }}>
                                        <div className="align" style={{ flex: '2', position: "relative" }}>
                                            <label><span style={{ color: "red" }}>*</span>License key</label>
                                            <input name="license_key" id="license_key"
                                                value={isEditingOrder ? orderDetails.license_key : license_key}
                                                disabled type="text" required></input>

                                            <button type="button" className="generate-license"
                                                onClick={() => {
                                                    generateLicense();
                                                }}
                                                disabled={isEditingOrder || isLicenseKeyAdded}
                                                title="Generate a license to create order"
                                            >Generate</button>
                                        </div>
                                    </div>
                                    <div style={{ flex: '1' }}>
                                        <div className="align">
                                            <label>Technician In Charge </label>
                                            <input name="technisian_name" disabled value={JSON.parse(sessionStorage.getItem("userdata")).te_username} type="text"></input>
                                        </div>
                                    </div>
                                </div>

                                <div className="align-item">
                                    <label>Order Description</label>
                                    {/* <input name="order_discription" type="text"></input> */}
                                    <textarea
                                        id="te_orderdescription"
                                        name="te_orderdescription"
                                        rows="4"
                                        cols="50"
                                        placeholder="Write your order description here...">
                                    </textarea>
                                </div>
                                <div>


                                    <button
                                        type="submit"
                                        className="create-company-button"
                                        disabled={!isLicenseGenerated || isCreatingOrder}
                                    >
                                        {isEditingOrder == false ? "Creating Order" : "Update Order"}
                                    </button>


                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
            <SuccessAlert />
            <FailureAlert />
        </div>
    )
}

export default CreateOrder